import React from 'react'
import bg from '../Images/homepage.jpg'
import "./Home.css"
import home21 from '../Images/home21.jpg'
import home22 from '../Images/home22.jpg'
import { Link } from 'react-router-dom'
import { motion} from 'framer-motion'

function Home() {
  return (
    <div>
    <div className='row mt-3 home1'>
        <div className='col-lg-6 col-12 col-md-6 mt-3 main'>
            <motion.div className='first'
                variants={{
                    hidden:{opacity:0,x:-100},
                    visible:{opacity:1,x:0}
                }}
                initial="hidden"
                animate="visible"
                transition={{duration:2,delay:0}}
            ></motion.div>
            <motion.div className='second'
                variants={{
                    hidden:{opacity:0,x:100},
                    visible:{opacity:1,x:0}
                }}
                initial="hidden"
                animate="visible"
                transition={{duration:2,delay:0}}
            ></motion.div>
            <motion.div className='third'
                variants={{
                    hidden:{opacity:0},
                    visible:{opacity:1}
                }}
                initial="hidden"
                animate="visible"
                transition={{duration:2,delay:0}}
            >
                <img src={bg} alt="bg" className='firstpic'></img>
            </motion.div>
        </div>
        <motion.div className='col-lg-6 col-12 col-md-6 d-flex flex-column justify-content-center'
            variants={{
                hidden:{opacity:0,y:100},
                visible:{opacity:1,y:0}
            }}
            initial="hidden"
            animate="visible"
            transition={{duration:2,delay:1}}
        >
            <h4 className='ms-5' style={{fontSize:"25px"}}>
                <strong>Welcome to</strong>
            </h4>
            <h3 className='ms-5 mt-2' style={{width:"300px", fontSize:"45px", color:"#6A3418"}}>
                <strong>B# Music Conservatory</strong>
            </h3>
        </motion.div>
    </div>

    <div className='row home2'>
        <div className='row mt-5'>
            <motion.div className='col-lg-6 col-md-6 col-12 d-flex flex-column align-items-end mt-5'
                variants={{
                    hidden:{opacity:0,x:-700},
                    visible:{opacity:1,x:0}
                }}
                initial="hidden"
                animate="visible"
                transition={{duration:2,delay:1,type:"spring"}}
            >
                <h3 className='text-end' style={{color:'#9F693A',width:"295px"}}>About Our Music School</h3>
                <div className='text-end mt-3' style={{width:"295px"}}>
                    <p style={{color:'#150F11',lineHeight:"1.9"}}>
                    B Sharp Music School is a upcoming provider of music education. 
                    We offer a wide range of programs for students of all ages and levels, from beginners to advanced musicians. 
                    Our experienced and qualified instructors are passionate about music and helping their students succeed.
                    </p>
                </div>
            </motion.div>
            <motion.div className='col-lg-6 col-md-6 col-12'
                variants={{
                    hidden:{opacity:0,x:700},
                    visible:{opacity:1,x:0}
                }}
                initial="hidden"
                animate="visible"
                transition={{duration:2,delay:1,type:"spring"}}
            >
                <img src={home22} style={{width:"295px", height:"442px"}} alt="home pic 2"></img>
            </motion.div>
        </div>
        <div className='row'>
            <motion.div className='col-lg-6 col-md-6 col-12 d-flex justify-content-end'
                variants={{
                    hidden:{opacity:0,x:-700},
                    visible:{opacity:1,x:0}
                }}
                initial="hidden"
                animate="visible"
                transition={{duration:2,delay:1,type:"spring"}}
            >
                <img src={home21} style={{width:"295px", height:"442px"}} alt="home pic"></img>
            </motion.div>
            <motion.div className='col-lg-6 col-md-6 ms-3 col-12 mt-4' style={{width:"295px"}}
                variants={{
                    hidden:{opacity:0,x:700},
                    visible:{opacity:1,x:0}
                }}
                initial="hidden"
                animate="visible"
                transition={{duration:2,delay:1,type:"spring"}}
            >
                <p style={{color:'#150F11',lineHeight:"1.9"}}>
                B Sharp Music School is a upcoming provider of music education. 
                We offer a wide range of programs for students of all ages and levels, from beginners to advanced musicians. 
                Our experienced and qualified instructors are passionate about music and helping their students succeed.
                </p>
                <div className='d-flex justify-content-center'>
                    <button className='btn' style={{backgroundColor:"#CEA77E",borderRadius:"15px"}}>
                        <Link to={"/About"} style={{textDecoration:"none",color:'#150F11'}}><strong>Courses</strong></Link>
                    </button>
                </div>
            </motion.div>
        </div>
        
    </div>
    </div>
  )
}

export default Home